import { Repository } from "../../adapters/repository";
import { DateOps } from "../../adapters/dateOps";
import { present } from "../../../utils/presenter";
import { validateUnAvailability } from "../../entities/unAvailabilityValidator";
import { findError } from "../../../entities/errorChecker";
import { Interactor } from "./types";

function createInteractor(
  repository: Repository,
  dateOps: DateOps,
): Interactor {
  return ({ planzone, unavailability }) => {
    const error = validateUnAvailability(dateOps, unavailability);

    return present(
      !findError(error)
        ? repository
            .saveUnavailability(planzone, unavailability)
            .then((savedUnavailability) => ({
              planzone,
              unavailability: savedUnavailability,
            }))
            .catch((e) =>
              Promise.reject({
                planzone,
                unavailability,
                error: { ...error, ...e },
              }),
            )
        : Promise.reject({ planzone, unavailability, error }),
    );
  };
}

export type { Interactor };

export { createInteractor };
